<app-loader *ngIf="loading"></app-loader>
<ng-container *ngIf="!loading">
  <highcharts-chart
    *ngIf="chartOptions; else noData"
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    style="width: 100%; display: block;">
  </highcharts-chart>
  <ng-template #noData>
    <app-no-widget-data></app-no-widget-data>
  </ng-template>
</ng-container>
